/**
 * Configuration for public-facing URLs that don't require authentication
 */

export const PUBLIC_URL_PREFIXES = [
  "/login",
  "/auth/",
  "/signup",
  "/logout",
  "/supplier-wizard/",
] as const;

export type PublicUrlPrefix = (typeof PUBLIC_URL_PREFIXES)[number];

/**
 * Checks if a given URL pathname starts with any of the public URL prefixes
 * @param pathname The URL pathname to check
 * @returns boolean indicating if the pathname is public
 */
export function isPublicUrl(pathname: string): boolean {
  return PUBLIC_URL_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
